import { render, staticRenderFns } from "./returnMgmt.vue?vue&type=template&id=14f933ba"
import script from "./returnMgmt.vue?vue&type=script&lang=js"
export * from "./returnMgmt.vue?vue&type=script&lang=js"
import style0 from "./returnMgmt.vue?vue&type=style&index=0&id=14f933ba&prod&v-slot=scope&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports